import React from 'react';
import '../styles/preloader.css';
// Using your specific filename here
import coffeeLoader from '../assets/images/logo-gif.gif'; 

const Preloader = () => {
  return (
    <div className="preloader-wrapper">
      <div className="loader-container">
        <img 
          src={coffeeLoader} 
          alt="Aditya Exports Loading" 
          className="loader-gif" 
        />
        <div className="loader-text-area">
          <p className="loading-text">Aditya Exports</p>
          <div className="loader-accent-line"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;